import {
  AUTH_TYPE_CHECK,
  AUTH_TYPE_CHECK_FAILURE,
  AUTH_TYPE_CHECK_SUCCESS,
  LOGIN_RESET,
  GO_AUTH_AUTHENTICATE,
  GO_AUTH_AUTHENTICATE_FAILURE,
  GO_AUTH_AUTHENTICATE_SUCCESS,
  MOKA_AUTHENTICATE,
  MOKA_AUTHENTICATE_FAILURE,
  MOKA_AUTHENTICATE_SUCCESS,
} from './types';

export function checkAuthType(email, phoneNumber) {
  return {
    type: AUTH_TYPE_CHECK,
    payload: {
      email,
      phoneNumber,
    },
  };
}

export function checkAuthTypeSuccess(
  authType,
  isNewlyAssociated = false,
  association = {}
) {
  return {
    type: AUTH_TYPE_CHECK_SUCCESS,
    payload: {
      authType,
      isNewlyAssociated,
      association,
    },
  };
}

export function checkAuthTypeFailure(error) {
  return {
    type: AUTH_TYPE_CHECK_FAILURE,
    error,
    payload: {
      error,
    },
  };
}

export function resetLogin() {
  return { type: LOGIN_RESET };
}

export function authenticateGoAuth(email, password, redirectTo) {
  return {
    type: GO_AUTH_AUTHENTICATE,
    payload: {
      email,
      password,
      redirectTo,
    },
  };
}

export function authenticateGoAuthSuccess(accessToken, refreshToken, expiry) {
  return {
    type: GO_AUTH_AUTHENTICATE_SUCCESS,
    payload: {
      accessToken,
      refreshToken,
      expiry,
    },
  };
}

export function authenticateGoAuthFailure(error) {
  return {
    type: GO_AUTH_AUTHENTICATE_FAILURE,
    error,
    payload: {
      error,
    },
  };
}

export function authenticateMoka(email, phone, password, redirectTo) {
  return {
    type: MOKA_AUTHENTICATE,
    payload: {
      email,
      phone,
      password,
      redirectTo,
    },
  };
}

export function authenticateMokaSuccess(accessToken, refreshToken, expiry) {
  return {
    type: MOKA_AUTHENTICATE_SUCCESS,
    payload: {
      accessToken,
      refreshToken,
      expiry,
    },
  };
}

export function authenticateMokaFailure(error) {
  return {
    type: MOKA_AUTHENTICATE_FAILURE,
    error,
    payload: {
      error,
    },
  };
}
